import { Badge, Button, Col, Collapse, Form, Row, Space } from 'antd';
import { useIntl } from 'react-intl';
import { FloatingFormItem } from '@/components/_common';
import { useState } from 'react';
import { useDisclosure, useWindowSize } from '@/hooks';
import CustomersSelectedModal from '@/components/_common/CustomersSelectedModal';
import { QuestReportInvoiceFormValues } from '@/core/domain/questReport/Reports/Invoice/Invoice.types';
import { FormInstance } from 'antd/es/form/Form';
import SuppliersSelectedModal from '@/components/_common/SuppliersSelectedModal';
import { Supplier } from '@/core/domain/people/Suppliers/Suppliers.types';
import CfopSelectField from '@/components/_common/CfopSelectField';
import { TaxePisCstSelect } from '@/components/_common/TaxesSelect';
import InsurerInfiniteSelectField from '@/components/_common/InsurerInfiniteSelectField';

interface Props {
  form: FormInstance<QuestReportInvoiceFormValues>;
}

const InvoiceMoreOptions: React.FC<Props> = ({ form }) => {
  const intl = useIntl();
  const { Panel } = Collapse;
  const { isMobile } = useWindowSize();

  const [openCustomer, setOpenCustomer] = useDisclosure(false);
  const [supplierVisible, setSupplierVisible] = useDisclosure(false);
  const [selectedCustomerIds, setSelectedCustomerIds] = useState<number[]>();
  const [supplierId, setSupplierId] = useState<number[]>();

  return (
    <Col>
      <Collapse accordion>
        <Panel
          header={intl.formatMessage({
            id: 'report.invoice.form.moreOptions',
          })}
          key={1}
        >
          <Row gutter={[24, 24]}>
            <Col xs={12}>
              <Button type="primary" onClick={setOpenCustomer.open}>
                <Space direction={isMobile ? 'vertical' : 'horizontal'}>
                  {intl.formatMessage({
                    id: 'report.invoice.form.moreOptions.selectCustomers',
                  })}

                  <Badge count={form.getFieldsValue().customerIds?.length} />
                </Space>
              </Button>

              <Form.Item name="customerIds" noStyle>
                <CustomersSelectedModal
                  visible={openCustomer}
                  handleVisible={setOpenCustomer.close}
                  selectedCustomerIds={selectedCustomerIds}
                  finishCallback={(customer) => {
                    setSelectedCustomerIds(customer);
                    form.setFieldValue('customerIds', customer);
                  }}
                />
              </Form.Item>
            </Col>

            <Col xs={12}>
              <Button type="primary" onClick={setSupplierVisible.open}>
                <Space direction={isMobile ? 'vertical' : 'horizontal'}>
                  {intl.formatMessage({
                    id: 'report.invoice.form.moreOptions.selectSuppliers',
                  })}

                  <Badge count={form.getFieldsValue().suppliersIds?.length} />
                </Space>
              </Button>

              <Form.Item name="suppliersIds" noStyle>
                <SuppliersSelectedModal
                  handleVisible={setSupplierVisible.close}
                  visible={supplierVisible}
                  finishCallback={(suppliers) => {
                    setSupplierId(suppliers);
                    form.setFieldValue('suppliersIds', suppliers);
                  }}
                  selectedSuppliers={
                    supplierId?.map((cur) => ({
                      id: cur,
                    })) as unknown as Supplier[]
                  }
                />
              </Form.Item>
            </Col>

            <Col xs={24} md={12}>
              <FloatingFormItem
                label={intl.formatMessage({
                  id: 'report.invoice.form.selection.insurer',
                })}
                name="insurerIds"
              >
                <InsurerInfiniteSelectField mode="multiple" allowClear />
              </FloatingFormItem>
            </Col>

            <Col xs={24} md={12}>
              <FloatingFormItem
                label={intl.formatMessage({
                  id: 'report.invoice.form.selection.cfop',
                })}
                name="cfopIds"
              >
                <CfopSelectField
                  queryFilter={{ hasInvoice: true }}
                  mode="multiple"
                />
              </FloatingFormItem>
            </Col>

            <Col xs={24} md={12}>
              <FloatingFormItem
                label={intl.formatMessage({
                  id: 'report.invoice.form.selection.cstpis/cofins',
                })}
                name="cstPisCofins"
              >
                <TaxePisCstSelect />
              </FloatingFormItem>
            </Col>
          </Row>
        </Panel>
      </Collapse>
    </Col>
  );
};

export default InvoiceMoreOptions;
